<template>
  <div id="bankruptcy" v-if="item.Bankruptcy === 'T'">
    <h3 class="h4">Bankruptcy Information</h3>
    <pre>{{ item.BankruptcyNotes }}</pre>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>
